'use strict';

var findTabbable = require('../helpers/tabbable');
var modalElement = null;
var focusLaterElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation 
    // is that the document.body gets focus, and then we focus our element right 
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) return;
      var el = findTabbable(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function () {
  focusLaterElement = document.activeElement;
};

exports.returnFocus = function () {
  try {
    focusLaterElement.focus();
  } catch (e) {
    console.warn('You tried to return focus to ' + focusLaterElement + ' but it is not in the DOM anymore');
  }
  focusLaterElement = null;
};

exports.setupScopedFocus = function (element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function () {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/react-modal-onfido/lib/helpers/focusManager.js
// module id = 442
// module chunks = 1